<prlw-mobile-details-card-ui
  [title]="title$ | async"
  [briefDescription]="briefDescription$ | async"
  descriptionLabel="Лучшее по цене"
  [descriptionValue]="descriptionValue$ | async"
  [greyTopItems]="greyTopItems$ | async"
  [whiteTopItems]="whiteTopItems$ | async"
  [whiteBottomItems]="whiteBottomItems$ | async"
  [priceOption]="priceOption$ | async"
  (eventClickPriceOptions)="handleClickPriceOptions()"
  (eventClickInfoIcon)="handleClickAboutBasis()"
  (eventClickDetails)="handleClickDetails()"
>
  <prlw-text-tag-otp
    tag
    [instrumentCode]="instrumentCode$ | async"
    size="medium"
  ></prlw-text-tag-otp>
</prlw-mobile-details-card-ui>
